
  <div (click)="onVideoClicked(video)" *ngIf="hasMultipleVideos" >
    <img [src]="video.thumbUrl">
    <div class="play">
      <i class="fa-brands fa-youtube"></i>
    </div>
  </div>

  <a [href]="video.pro?.url360 || video.pro?.url" target="_blank" data-type="normal"  *ngIf="!hasMultipleVideos && (video.pro?.url || video.pro?.url360)">
    <img [src]="video.thumbUrl">
    <div class="play">
      <i class="fa-brands fa-youtube"></i>
    </div>
  </a>
